import React from 'react';
import styles from './TextCard.module.css';

interface CardProps {
    title: string;
    description: string;
    seeMore: string;
    type: string;
}

export default function TextCard({ title, description, seeMore, type }: CardProps) {
    const buttonClassName = type === 'publicacoes' ? styles.publicacoesButton : styles.extensonsButton;

    return (
        <div className={`${styles.card}`}>
            <p className={styles.cardTitle}>{title}</p>
            <p className={styles.cardDescription}>{description}</p>
            <div className={styles.cardButtonContainer}>
                <button className={buttonClassName}>
                    {seeMore}
                </button>
            </div>
        </div>
    );
}